/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNCAxMS43MUw3Ljk5OTk4IDUuNzEwMDFMMS45OTk5OCAxMS43MUwxLjI4OTk4IDExTDcuOTk5OTggNC4yOTAwMUwxNC43MSAxMUwxNCAxMS43MVoiIGZpbGw9ImluaGVyaXQiLz4=";